/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, FC } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    FormControlLabel,
    FormControl,
    Radio,
    RadioGroup,
    Typography,
    useMediaQuery,
  } from "@mui/material";
import { FullWidthButton } from "src/framework/components/buttons/FullWidthButton";
import { IDataRequest, IDataResponse, STATUS_CODE, apiNoLoading } from "src/framework/providers/api";
import { notifierStore } from "src/framework/store/NotifierStore";
import { EnviarPagamentoProperties, RequestEnviarPagamento } from "./types";
import theme from "src/theme/light";
import { CarrinhoKitsResponse, ProjetosProvider } from "src/providers/ProjetosProvider";
import adminStore from "src/store/AdminStore";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import moment from "moment";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { DadosFinalizar } from "../../containers/TermosFinalizar";
import "./styles.css";
import { isLoading$ } from "src/framework/store/ApiEvents";

const EnviarPagamento: FC<EnviarPagamentoProperties> = ({
    open = true,
    idprojeto,
    onClose,
    onSuccess,
}) => {
    const [loading, setLoading] = useState(false)
    const [codigoVenda, setCodigoVenda] = useState<string>();
    const [isTriangular, setIsTriangular] = useState<boolean>(false);
    const [tipoProposta, setTipoProposta] = useState<string | null>(null);
    const [exibirTipoProposta, setExibirTipoProposta] = useState<boolean>(false);
    const [emailProposta, setEmailProposta] = useState(null);
    const [errorEmail, setErrorEmail] = useState(false);
    const [dataDisponibilidade, setDataDisponibilidade] = useState<string>();
    const [dataAtual] = useState<string>(String(moment(new Date()).format("DD/MM/YYYY")));
    const userInfo = LocalStorage.get("solar.userExtraInfo", true);
    const [dadosFinalizar, setDadosFinalizar] = useState<DadosFinalizar>();

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const FooterBottom = isMobile ? Box : DialogActions;
    
    const enviarPagamento = async (): Promise<void> => {
        if (loading) return;

        if (codigoVenda){
            // verifica vigência substituição EV
            let vigencia = true
            if (idprojeto) {
                await adminStore.buscarProjeto(idprojeto, true).then(resp => {
                    if (!resp?.length) vigencia = false;
                });
            }
            if (!vigencia) return;

            const dataRequest: RequestEnviarPagamento = {
                codigo_venda: codigoVenda,
                nota_fiscal_triangular: isTriangular,
                tipo_proposta_envio: tipoProposta,
                email_cliente_pagador: emailProposta,
                dados_finalizar: dadosFinalizar
            }
            const request: IDataRequest = {
                url: "/projetos/enviar_pagamento",
                data: dataRequest
            }

            const response: IDataResponse = await apiNoLoading.post(request);

            if (response.statusCode === STATUS_CODE.OK){
                notifierStore.setNotifier({
                    title: "Aviso!",
                    content: "Sucesso no envio para pagamento!",
                    timeOut: 0,
                    onClose: () => {
                    notifierStore.setOpen(false);
                    onSuccess();
                    onClose();
                    }
                })
                notifierStore.setOpen(true);
            } else if (response.statusCode === STATUS_CODE.BAD_REQUEST) {
                const errors = response.message;
                let _errors = []
                for (let i = 0; i < errors.length; i++){
                    _errors.push(errors[i]);
                }
                notifierStore.setNotifier({
                    title: "Aviso!",
                    content: _errors,
                    timeOut: 0,
                    onClose: () => {
                    notifierStore.setOpen(false)
                    }
                })
                notifierStore.setOpen(true);
            } else {
                notifierStore.setNotifier({
                    title: "Aviso!",
                    content: "Falha no envio para pagamento!",
                    timeOut: 0,
                    onClose: () => {
                    notifierStore.setOpen(false)
                    }
                })
                notifierStore.setOpen(true);
            }
        }
    }
    const loadCodProjeto = async()=>{
        if (idprojeto){
            isLoading$.next(true);
            const request: IDataRequest = {
                url: `/projetos?id=${idprojeto}&includes=uploads,componentes`
            }
            const response = await apiNoLoading.get(request)
            if(response.statusCode === STATUS_CODE.OK) {
                const { tipo, segmento, codigo_venda, tipo_faturamento, email_proposta, componentes, estado_id } = response.data[0] || {};
                const componentesBusca = parseComponentes(componentes);
                setCodigoVenda(codigo_venda);
                setIsTriangular(tipo_faturamento === "integrador_cliente");
                setEmailProposta(email_proposta)
                if (tipo_faturamento === 'cliente') {
                    setExibirTipoProposta(true);
                }
                if (segmento?.includes('offgrid')) {
                    setExibirTipoProposta(false);
                } else {
                    switch (tipo) {
                        case "personalizado":
                            if(["integrador", "integrador_cliente"].includes(tipo_faturamento)){
                                setExibirTipoProposta(false)
                            }
                            if (codigo_venda?.includes("HIBRI")) {
                                setExibirTipoProposta(false);
                            }
                            break;
                        case "dimensionado":
                            if(codigo_venda?.includes("HIBRI")){
                                setExibirTipoProposta(false);
                            }else{
                                setExibirTipoProposta(true)
                            }
                            break;
                        case "kit":
                            const projetosProvider = new ProjetosProvider();
                            const resultKits = await projetosProvider.buscarCarrinhoKits(codigo_venda || '');
                            const kits: CarrinhoKitsResponse | null = resultKits?.data?.[0] || null;
                            if (kits?.itens?.length === 1 && kits?.itens[0]?.quantidade === 1) {
                                setExibirTipoProposta(true);
                            } else {
                                setExibirTipoProposta(false)
                            }
                            break;
                        default:
                            setExibirTipoProposta(false)
                            break;
                    }
                }
                if(estado_id && componentesBusca.length){
                    const requestPrevisao: IDataRequest = {
                        url: "/projetos/previsao_faturamento",
                        data: {
                            uf: estado_id,
                            componentes: componentesBusca,
                            segmento: segmento?.includes("on") ? "on" : "off"
                        }
                    }
                    const resultPrevisao = await apiNoLoading.post(requestPrevisao);
                    if (resultPrevisao.statusCode === STATUS_CODE.OK){
                        setDataDisponibilidade(parseDataDisponibilidade(resultPrevisao.data.data.data_previsao_faturamento));
                    }
                }
            }
            isLoading$.next(false);
        }
    }
    const validateEmail = (email: string) => {
        return !!String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    };
    const validate = (): boolean => {
        const messages: string[] = [];
        
        if (!emailProposta) {
            setErrorEmail(true)
            messages.push('O campo "E-mail do cliente pagador" é obrigatório!');
        }else if(!validateEmail(emailProposta)){
            setErrorEmail(true);
            messages.push('O e-mail informado é inválido!');
        }
        if (!tipoProposta){
            messages.push("É necessário selecionar a proposta à ser enviada por e-mail!")
        }
        if (messages.length > 0) {
          notifierStore.setNotifier({
            title: "Aviso",
            content: messages,
            timeOut: 3500,
            onClose: () => {
              notifierStore.setOpen(false)
            }
          })
          notifierStore.setOpen(true)
          return false;
        }
        return messages.length === 0;
      }
    const parseComponentes = (componentes: any[]) => {
        return componentes.filter((item) => item.quantidade > 0).map((item) => ({
            codigo: item.componente_id,
            quantidade: item.quantidade,
        }));
    }
    const parseDataDisponibilidade = (data_previsao_faturamento: string) => {
        const aDatas = data_previsao_faturamento.split("-");
        const dataFormatada = aDatas[2] + "/" + aDatas[1] + "/" + aDatas[0];
        return dataFormatada;
    }
    useEffect(()=>{
        loadCodProjeto();
    },[idprojeto]);

    useEffect(()=>{
        //monta os dados de finalizacao
        const dados: DadosFinalizar  = {
            data_atual: dataAtual,
            data_disponibilidade: dataDisponibilidade,
            confirmado_em: new Date(),
            user_id: userInfo?.userId,
        };
        setDadosFinalizar(dados);
    },[dataDisponibilidade])
    return (
        <>
            { codigoVenda && dataDisponibilidade? (
                <>
                <Box
                    style={!isMobile ? {width: "1400px"} : {}}
                >
                    <Dialog 
                        open={open}
                        maxWidth={'md'}
                        className={"modal-enviar-pagamento"}
                    >
                        <DialogTitle id="dialog-enviar-pagamento">
                            Atenção!                
                        </DialogTitle>
                        <DialogContent>
                        <Box 
                            style={{
                                fontFamily:"inherit",
                                color: `${theme.palette.grey[800]}`,
                            }}>
                        <Box
                            style={isMobile ? {maxWidth: "700px"} : {}}
                        >
                            <Typography variant="body1" style={{marginBottom: "10px"}}>
                                O faturamento será realizado até <strong style={{ color: theme.palette.primary.main }}>{dataDisponibilidade}</strong>, caso o pagamento seja reconhecido hoje (<strong style={{ color: theme.palette.primary.main }}>{dataAtual}</strong>), podendo ser antecipado de acordo com a disponibilidade.
                            </Typography>
                            <Typography variant="body1"><strong>OBS.: Para projetos com financiamento bancário, o prazo está condicionado à liberação dos recursos pela instituição financeira.</strong></Typography>
                        </Box>
                        <FormControl>
                            <h3>Selecione a proposta que será enviada por e-mail:</h3>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    value={tipoProposta}
                                    name="radio-buttons-group"
                                    onChange={(e: any) => {
                                        setTipoProposta(e.target.value)                            
                                    }}
                                >
                                    <FormControlLabel value="simplificada" control={<Radio style={{color: "green"}}/>} label="Proposta Simplificada"/>
                                    &nbsp;
                                    {exibirTipoProposta && (
                                        <FormControlLabel value="detalhada" control={<Radio style={{color: "green"}}/>} label="Proposta Detalhada"/>
                                    )}
                                    &nbsp;
                                    <FormControlLabel value="link" control={<Radio style={{color: "green"}}/>} label="Enviar apenas o link"/>
                                </RadioGroup>
                        </FormControl>
                        <h3>Informe o e-mail que receberá os dados para pagamento:</h3>
                        <InputText label="* E-mail do cliente pagador" fullWidth
                            value={emailProposta}
                            error={errorEmail}
                            helperText={errorEmail ? "E-mail inválido" : ''}
                            inputProps={{
                                autocomplete: 'off',
                            }}
                            onChange={(e: any) => {
                                setEmailProposta(e.target.value);
                            }}
                            onKeyDown={(e: any) => {
                                const spaceRegex = /\s/g
                                e.target.value = e.target.value.replace(spaceRegex, '')
                            }}
                            onKeyUp={(e: any) => {
                                if (e.target.value !== "") {
                                    let erro = false;
                                    if (ValidateUtil.isValidEmail(e.target.value) && validateEmail(e.target.value)) {
                                        erro = false;
                                    } else {
                                        erro = true;
                                    }
                                    setErrorEmail(erro);
                                }
                            }}
                        />
                        </Box>
                        </DialogContent>
                        <FooterBottom className="footer-enviar-pagamento" style={isMobile ? { display: "flex", flexDirection: "column-reverse", width: "100%", padding: "15px 25px" } : {}}>
                            <FullWidthButton 
                                disabled={loading}
                                fullWidth={isMobile}
                                color="secondary"
                                variant="outlined"
                                disableElevation
                                text="Cancelar"
                                onClick={() => {
                                    onClose();
                                }}
                            />
                            <FullWidthButton
                                disabled={!tipoProposta || loading || errorEmail}
                                fullWidth={isMobile}
                                color="primary"
                                variant="contained"
                                disableElevation
                                text={loading ? "Enviando..." : "Enviar"}
                                onClick={async () => {
                                    if (!validate()) return;
                                    setLoading(true);
                                    await enviarPagamento();
                                    setLoading(false);
                                }}
                            />
                        </FooterBottom>
                    </Dialog>
                </Box>
            </>)
            : <></>}
        </>
    );
};
export { EnviarPagamento };